<section class="donor-card cmnh-card simple">
    <div class="card-body">
        <div class="donor-grid">
            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(firstname)"
                [class.donor-field--invalid]="isFieldInvalid(firstname)">

                <app-cmn-input [label]="'FIRST_NAME' | translate" inputId="firstName" name="firstName" type="text"
                    maxlength="50" #firstname="ngModel" [(ngModel)]="donorEditCommon.donor.firstName"
                    [required]="!companyName.value" [control]="firstname"
                    [showError]="showError(firstname)"
                    (valueChanged)="onNameChange.emit()">
                </app-cmn-input>
            </div>

            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(lastname)"
                [class.donor-field--invalid]="isFieldInvalid(lastname)">
                <app-cmn-input [label]="'LAST_NAME' | translate" inputId="lastName" name="lastName" type="text"
                    maxlength="50" #lastname="ngModel" [(ngModel)]="donorEditCommon.donor.lastName"
                    [required]="!companyName.value" [control]="lastname"
                    [showError]="showError(lastname)"
                    (valueChanged)="onNameChange.emit()">
                </app-cmn-input>
            </div>

            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(companyName) && !!companyName.value"
                [class.donor-field--invalid]="isFieldInvalid(companyName)">
                <app-cmn-input [label]="'COMPANY_NAME' | translate" inputId="companyName" name="companyName" type="text"
                    maxlength="50" #companyName="ngModel" [(ngModel)]="donorEditCommon.donor.companyName"
                    [required]="!firstname.value && !lastname.value" [control]="companyName"
                    [showError]="showError(companyName)"
                    [requiredMessage]="'VALIDATION_COMPANY_NAME' | translate"
                    (valueChanged)="onNameChange.emit()">
                </app-cmn-input>
            </div>

            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(email)"
                [class.donor-field--invalid]="isFieldInvalid(email)">
                <app-cmn-input [label]="'EMAIL' | translate" inputId="email" name="email" type="email" email required
                    maxlength="128" #email="ngModel" [(ngModel)]="donorEditCommon.donor.email" [control]="email"
                    [showError]="showError(email)">
                </app-cmn-input>
            </div>

            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(telephone)"
                [class.donor-field--invalid]="isFieldInvalid(telephone)">

                <app-cmn-input [label]="'TELEPHONE' | translate" inputId="telephone" name="telephone" type="tel" required
                    minlength="7" maxlength="14" pattern="^[0-9]+$" #telephone="ngModel"
                    [(ngModel)]="donorEditCommon.donor.telephone" [control]="telephone"
                    [showError]="showError(telephone)"
                    [showMaxlengthReached]="telephone.value?.length === 14 && showError(telephone)"
                    [minlengthMessage]="'VALIDATION_PHONE_MIN_LENGTH' | translate"
                    [patternMessage]="'VALIDATION_NUMBERS_ONLY' | translate"></app-cmn-input>
            </div>

            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(postalcode)"
                [class.donor-field--invalid]="isFieldInvalid(postalcode)">
                <app-cmn-input [label]="'POSTAL_CODE' | translate" inputId="postalCode1" name="postalCode1" type="text"
                    searchIcon [loading]="donorEditCommon.lookingUpZip" required maxlength="15" #postalcode="ngModel"
                    [(ngModel)]="donorEditCommon.donor.postalCode" [control]="postalcode"
                    [showError]="showError(postalcode)" autocomplete="postal-code"
                    (inputBlur)="
              donorEditCommon.lookUpZipBlur(donorEditCommon.donor.postalCode);
              donorEditCommon.getLocalizedHospital(donorEditCommon.donor.postalCode)
            "></app-cmn-input>
            </div>

            <div class="donor-field donor-field--full"
                [class.donor-field--valid]="isFieldValid(address1)"
                [class.donor-field--invalid]="isFieldInvalid(address1)">
                <app-cmn-input [label]="'ADDRESS_1' | translate" inputId="address1" name="address1" type="text" required
                    maxlength="50" #address1="ngModel" [(ngModel)]="donorEditCommon.donor.address1" [control]="address1"
                    [showError]="showError(address1)"></app-cmn-input>
            </div>

            <div class="donor-field donor-field--full"
                [class.donor-field--valid]="isFieldValid(address2)"
                [class.donor-field--invalid]="isFieldInvalid(address2)">
                <app-cmn-input [label]="'ADDRESS_2' | translate" inputId="address2" name="address2" type="text" maxlength="50"
                 #address2="ngModel" [(ngModel)]="donorEditCommon.donor.address2" [control]="address2"
                 [showError]="showError(address2)"></app-cmn-input>
            </div>

            <div class="donor-field" [class.donor-field--valid]="isFieldValid(city)"
                [class.donor-field--invalid]="isFieldInvalid(city)">
                <app-cmn-input [label]="'CITY' | translate" inputId="city" name="city" type="text" required maxlength="50"
                    #city="ngModel" [(ngModel)]="donorEditCommon.donor.city" [control]="city"
                    [showError]="showError(city)"></app-cmn-input>
            </div>

            <div class="donor-field"
                [class.donor-field--valid]="isFieldValid(stateId)"
                [class.donor-field--invalid]="isFieldInvalid(stateId)">
                <label class="cmnh-select-label donor-label" for="stateId">
                    {{ "STATE" | translate }}<span class="required-field">*</span>
                </label>
                <select class="cmnh-select donor-control donor-select" id="stateId" name="stateId" #stateId="ngModel" required
                    [(ngModel)]="donorEditCommon.donor.stateId">
                    <option class="cmnh-select-option" value="">--Select State--</option>

                    @for (ctype of donorEditCommon.states; track ctype) {
                    <option class="cmnh-select-option" [ngValue]="ctype.value">
                        {{ ctype.label }}
                    </option>
                    }
                </select>
                @if (isFieldInvalid(stateId)) {
                <span class="donor-error">
                    {{ "THIS_FIELD_IS_REQUIRED" | translate }}
                </span>
                }
            </div>
        </div>
    </div>
</section>
